/* tslint:disable */
/* eslint-disable */
/**
 * A2B Token API
 * Authentication token interaction API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExchangeTokenRequest } from '../model';
// @ts-ignore
import type { TokenResult } from '../model';
/**
 * SSOInteractionApi - axios parameter creator
 */
export const SSOInteractionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used to exchange a supported SSO ID token with a API compatible token. The resulting token will be a JWT and needs to be refreshed in time (see token valid time).
         * @summary Exchange SSO ID token
         * @param {ExchangeTokenRequest} exchangeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken: async (exchangeTokenRequest: ExchangeTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exchangeTokenRequest' is not null or undefined
            assertParamExists('exchangeToken', 'exchangeTokenRequest', exchangeTokenRequest)
            const localVarPath = `/v1/token/exchange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exchangeTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to refresh JWT obtained by exchanging a SSO ID token. Cannot be used to refresh other API tokens.
         * @summary Refresh JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SSOInteractionApi - functional programming interface
 */
export const SSOInteractionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SSOInteractionApiAxiosParamCreator(configuration)
    return {
        /**
         * Used to exchange a supported SSO ID token with a API compatible token. The resulting token will be a JWT and needs to be refreshed in time (see token valid time).
         * @summary Exchange SSO ID token
         * @param {ExchangeTokenRequest} exchangeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeToken(exchangeTokenRequest: ExchangeTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeToken(exchangeTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOInteractionApi.exchangeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used to refresh JWT obtained by exchanging a SSO ID token. Cannot be used to refresh other API tokens.
         * @summary Refresh JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SSOInteractionApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SSOInteractionApi - factory interface
 */
export const SSOInteractionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SSOInteractionApiFp(configuration)
    return {
        /**
         * Used to exchange a supported SSO ID token with a API compatible token. The resulting token will be a JWT and needs to be refreshed in time (see token valid time).
         * @summary Exchange SSO ID token
         * @param {SSOInteractionApiExchangeTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeToken(requestParameters: SSOInteractionApiExchangeTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResult> {
            return localVarFp.exchangeToken(requestParameters.exchangeTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Used to refresh JWT obtained by exchanging a SSO ID token. Cannot be used to refresh other API tokens.
         * @summary Refresh JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: RawAxiosRequestConfig): AxiosPromise<TokenResult> {
            return localVarFp.refreshToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exchangeToken operation in SSOInteractionApi.
 */
export interface SSOInteractionApiExchangeTokenRequest {
    readonly exchangeTokenRequest: ExchangeTokenRequest
}

/**
 * SSOInteractionApi - object-oriented interface
 */
export class SSOInteractionApi extends BaseAPI {
    /**
     * Used to exchange a supported SSO ID token with a API compatible token. The resulting token will be a JWT and needs to be refreshed in time (see token valid time).
     * @summary Exchange SSO ID token
     * @param {SSOInteractionApiExchangeTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exchangeToken(requestParameters: SSOInteractionApiExchangeTokenRequest, options?: RawAxiosRequestConfig) {
        return SSOInteractionApiFp(this.configuration).exchangeToken(requestParameters.exchangeTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used to refresh JWT obtained by exchanging a SSO ID token. Cannot be used to refresh other API tokens.
     * @summary Refresh JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshToken(options?: RawAxiosRequestConfig) {
        return SSOInteractionApiFp(this.configuration).refreshToken(options).then((request) => request(this.axios, this.basePath));
    }
}

